import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { Alert } from '@openedx/paragon';
import { CheckCircle, Error } from '@openedx/paragon/icons';
import PropTypes from 'prop-types';

import {
  COMPLETE_STATE, FORBIDDEN_STATE, FORM_SUBMISSION_ERROR, INTERNAL_SERVER_ERROR } from '../data/constants';
import { PASSWORD_RESET } from '../reset-password/data/constants';
import { useT } from '../context/LanguageContext';

const ForgotPasswordAlert = (props) => {
  const { t } = useT();
  const { email, emailError } = props;
  let message = '';
  let heading = t('forgot.password.error.alert.title');
  let { status } = props;

  if (emailError) {
    status = FORM_SUBMISSION_ERROR;
  }

  switch (status) {
    case COMPLETE_STATE:
      heading = t('confirmation.message.title');
      message = t('forgot.password.confirmation.message', {
            email: <span className="data-hj-suppress">{email}</span>,
            supportLink: (
              <Alert.Link href={getConfig().PASSWORD_RESET_SUPPORT_LINK} target="_blank">
                {t('confirmation.support.link')}
              </Alert.Link>
            ),
          });
     break;
    case INTERNAL_SERVER_ERROR:
      message = t('internal.server.error');
      break;
    case FORBIDDEN_STATE:
      heading = t('forgot.password.error.message.title');
      message = t('forgot.password.request.in.progress.message');
      break;
    case FORM_SUBMISSION_ERROR:
      message = t('extend.field.errors', { emailError });
      break;
    case PASSWORD_RESET.INVALID_TOKEN:
      heading = t('invalid.token.heading');
      message = t('invalid.token.error.message');
      break;
    case PASSWORD_RESET.FORBIDDEN_REQUEST:
      heading = t('token.validation.rate.limit.error.heading');
      message = t('token.validation.rate.limit.error');
      break;
    case PASSWORD_RESET.INTERNAL_SERVER_ERROR:
      heading = t('token.validation.internal.sever.error.heading');
      message = t('token.validation.internal.sever.error');
      break;
    default:
      break;
  }

  if (message) {
    return (
      <Alert
        id="validation-errors"
        className="mb-4"
        variant={`${status === 'complete' ? 'success' : 'danger'}`}
        icon={status === 'complete' ? CheckCircle : Error}
      >
        <Alert.Heading>{heading}</Alert.Heading>
        <p>{message}</p>
      </Alert>
    );
  }
  return null;
};

ForgotPasswordAlert.defaultProps = {
  email: '',
  emailError: '' };

ForgotPasswordAlert.propTypes = {
  status: PropTypes.string.isRequired,
  email: PropTypes.string,
  emailError: PropTypes.string };

export default ForgotPasswordAlert;
